module.exports = __webpack_public_path__ + "img/tks_music.c2db1c8a.png";